import { render, staticRenderFns } from "./ZhongBao.vue?vue&type=template&id=72511d7b&scoped=true&"
import script from "./ZhongBao.vue?vue&type=script&lang=js&"
export * from "./ZhongBao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72511d7b",
  null
  
)

export default component.exports